import React from 'react';
import { Image, SingleLineCaption } from './../../../components';

const CopyWrapper = (props) => (
  <div className={'formatted-markup copy ' + props.Copy.fonts + ' ' + props.Copy.text_size + ' ' + props.Style}>
    {
      (props.Style == 'single_column_copy')
      ? <div className='copy-wrapper' dangerouslySetInnerHTML={{__html:props.Copy.copy}}/> :
      (props.Style == 'full_column_copy')
      ? <div className='copy-wrapper' dangerouslySetInnerHTML={{__html:props.Copy.copy}}/> :
      (props.Style == 'single_column_copy_with_image')
      ? <div className={'copy-w-image-wrapper ' + props.Copy.image_placement}>
          <div className='copy-wrapper' dangerouslySetInnerHTML={{__html:props.Copy.copy}}/>
          <div className='image-container'>
            <Image source={props.Copy.urls.small}/>
            <SingleLineCaption
              Headline={props.Copy.metadata.title}
              Description={props.Copy.metadata.caption}
              Stacked={true}
            />
          </div>
        </div> :
      (props.Style == 'two_column_text_with_blockquote')
      ? <div className='two-col-blockquote-wrapper'>
          <div className='blockquote-wrapper' dangerouslySetInnerHTML={{__html:props.Copy.blockquote}}/>
          <div className='two-col-copy-wrapper' dangerouslySetInnerHTML={{__html:props.Copy.text_column}}/>
        </div>
      : null
    }
  </div>
);

export default CopyWrapper;



// WEBPACK FOOTER //
// ./src/pages/blog/blog_single/copy_wrapper.js